import axios from "axios";
import { api } from "constants/RotasAPI";
import { useMutation } from "react-query";

export const usePutInativarConfiguarcaoBuscaExterna = () => {
    return useMutation({
        mutationFn: async () => {
            const response = await axios.put(api.groupPay.putinativarConfiguracaoBuscaExterna
            );
            return response.data;
        }
    });
};
